import { render, staticRenderFns } from "./editModule.vue?vue&type=template&id=82ee274a&scoped=true&"
import script from "./editModule.vue?vue&type=script&lang=js&"
export * from "./editModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ee274a",
  null
  
)

export default component.exports